// extracted by mini-css-extract-plugin
export default {"notification-item":"MOeVb3","notification-item_pointer":"mOV9U8","notification-button":"OhiLq2","main":"HFBDPm","action-button":"Zwh0m4","text":"M_iCYt"};